import {
  OrbColor,
  ORB_COLORS,
  ORB_COLOR_LABELS,
} from "@/program/VariableState";

/**
 * 変数表示パネル - オーブの現在値をリアルタイム表示
 */
export class VariableDisplay {
  private container: HTMLElement;
  private valueElements: Record<OrbColor, HTMLElement>;

  constructor(parentElement: HTMLElement) {
    this.container = document.createElement("div");
    this.container.className = "variable-display";
    this.container.setAttribute("aria-label", "変数一覧");

    this.valueElements = {} as Record<OrbColor, HTMLElement>;

    ORB_COLORS.forEach((color) => {
      const item = document.createElement("div");
      item.className = "variable-display__item";

      const indicator = document.createElement("span");
      indicator.className = `variable-display__indicator orb-color--${color} orb-glow`;
      indicator.setAttribute("aria-hidden", "true");
      item.appendChild(indicator);

      const label = document.createElement("span");
      label.className = "variable-display__label sr-only";
      label.textContent = ORB_COLOR_LABELS[color];
      item.appendChild(label);

      const value = document.createElement("span");
      value.className = "variable-display__value";
      value.setAttribute("data-color", color);
      value.textContent = "0";
      item.appendChild(value);

      this.container.appendChild(item);
      this.valueElements[color] = value;
    });

    parentElement.appendChild(this.container);
  }

  /**
   * 指定色の値を更新
   */
  update(color: OrbColor, value: number): void {
    this.valueElements[color].textContent = String(value);
  }

  /**
   * 全変数を0にリセット
   */
  reset(): void {
    ORB_COLORS.forEach((color) => {
      this.valueElements[color].textContent = "0";
    });
  }

  /**
   * 全変数の値を一括更新
   */
  updateAll(values: Record<OrbColor, number>): void {
    ORB_COLORS.forEach((color) => {
      this.valueElements[color].textContent = String(values[color]);
    });
  }
}
